<span class="tw:break-words tw:whitespace-pre-line">
  {{ warningMessage }}
</span>
